module.exports = __webpack_public_path__ + "dynamo.6ac7a29444c5acc52918716e306ef55d.svg";